import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/surveys')({
  validateSearch: (search: Record<string, unknown>) => ({
    create: search.create === true || search.create === 'true',
  }),
  component: LegacySurveysRedirect,
});

function LegacySurveysRedirect() {
  const { create } = Route.useSearch();

  if (create) {
    return (
      <Navigate
        to="/dashboard/settings/appointment-forms/new"
        search={{ surface: 'BOOKING' }}
        replace
      />
    );
  }

  return <Navigate to="/dashboard/settings/appointment-forms" replace />;
}
